import { client } from '../../apiClient';

export interface ImportPromptsPayload {
  prompts: string[];
}

export const importPrompts = async (projectId: number, data: ImportPromptsPayload): Promise<boolean> => {
  return client(true, true)
    .post<boolean>(`/projects/${projectId}/monitors/import-csv`, data)
    .then((response) => response.data)
    .catch((error) => { throw error; });
};